import Store from 'repatch';

import State from '../core/State';
import Language from '../entity/Language';
import { setLanguage } from '../reducer/language';
import { setTranslations } from '../reducer/translations';
import ConfigurationStorage from '../service/persistent/ConfigurationStorage';
import TranslationBackend from '../service/TranslationBackend';

const AVAILABLE_LANGUAGES: Language[] = ['EN', 'JA'];

class ConfigurationChangingUsecase {
  private readonly store: Store<State>;
  private readonly configurationStorage: ConfigurationStorage;
  private readonly translationBackend: TranslationBackend;

  constructor({
    store,
    configurationStorage,
    translationBackend,
  }: {
    store: Store<State>;
    configurationStorage: ConfigurationStorage;
    translationBackend: TranslationBackend;
  }) {
    this.store = store;
    this.configurationStorage = configurationStorage;
    this.translationBackend = translationBackend;
  }

  public changeLanguage = async (language: string): Promise<void> => {
    const _language = this.sanitizeLanguage(language);

    await this.setLanguageAndTranslation(_language);

    this.configurationStorage.saveLanguage(_language);
  };

  public changeLanguageTemporarily = async (language: string): Promise<void> => {
    const _language = this.sanitizeLanguage(language);

    await this.setLanguageAndTranslation(_language);
  };

  private sanitizeLanguage = (language: string): Language => {
    if (AVAILABLE_LANGUAGES.includes(language as Language)) {
      // best match
      return language as Language;
    }

    const forwardMatch = AVAILABLE_LANGUAGES.find(l => l.startsWith(language.split('-')[0]));

    if (forwardMatch) {
      return forwardMatch;
    }

    return AVAILABLE_LANGUAGES[0] as Language;
  };

  private setLanguageAndTranslation = async (language: Language): Promise<void> => {
    const translations = await this.translationBackend.get(language);

    this.store.dispatch(setTranslations(translations));
    this.store.dispatch(setLanguage(language));
  };
}

export default ConfigurationChangingUsecase;
